import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "spinner"]

  connect() {
    this.hideLoading()

    this.handleTurboComplete = this.handleTurboComplete.bind(this)
    this.handleTurboError = this.handleTurboError.bind(this)

    document.addEventListener('turbo:submit-end', this.handleTurboComplete)
    document.addEventListener('turbo:frame-load', this.handleTurboComplete)
    document.addEventListener('turbo:frame-render', this.handleTurboComplete)
    document.addEventListener('turbo:fetch-request-error', this.handleTurboError)
    document.addEventListener('turbo:before-cache', this.handleTurboComplete)
    document.addEventListener('turbo:load', this.handleTurboComplete)
  }

  disconnect() {
    document.removeEventListener('turbo:submit-end', this.handleTurboComplete)
    document.removeEventListener('turbo:frame-load', this.handleTurboComplete)
    document.removeEventListener('turbo:frame-render', this.handleTurboComplete)
    document.removeEventListener('turbo:fetch-request-error', this.handleTurboError)
    document.removeEventListener('turbo:before-cache', this.handleTurboComplete)
    document.removeEventListener('turbo:load', this.handleTurboComplete)
  }

  handleTurboComplete() {
    this.hideLoading()
  }

  handleTurboError() {
    this.hideLoading()
  }

  showLoading() {
    const group = this.element.getAttribute('data-uikit--loading-button-sync-group-value') || ''
    if (group.length > 0) {
      document.querySelectorAll('[data-uikit--loading-button-sync-group-value]').forEach((el) => {
        if (el.getAttribute('data-uikit--loading-button-sync-group-value') !== group) return
        const ctrl = this.application.getControllerForElementAndIdentifier(el, 'uikit--loading-button')
        if (ctrl) ctrl.showLoadingState()
      })
    } else {
      this.showLoadingState()
    }
  }

  showLoadingState() {
    if (this.hasTextTarget) {
      this.textTarget.style.display = 'none'
    }
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('hidden')
      this.spinnerTarget.style.display = ''
    }
    if (this.element) {
      this.element.setAttribute('aria-busy', 'true')
    }
  }

  hideLoading() {
    if (this.hasTextTarget) {
      this.textTarget.style.display = ''
      const idleBtn = this.textTarget.querySelector('button')
      if (idleBtn) {
        idleBtn.disabled = false
        idleBtn.removeAttribute('aria-busy')
      }
    }
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add('hidden')
      this.spinnerTarget.style.display = 'none'
    }
    if (this.element) {
      this.element.removeAttribute('aria-busy')
    }
  }
}
